import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessReportsOverviewRoute: InvariantJiraRoute = {
	name: 'classic-business-reports-overview',
	path: '/jira/core/projects/:projectKey/reports',
	exact: true,
	query: ['dashboardId?'],
};
